'use client';

import Link from 'next/link';
import type { ReactNode } from 'react';

import { trackPseoCtaClick, type PseoCtaSurface } from '@/components/pseo/track-pseo-cta';

/** A `<Link>` that reports the click before navigating. Keeps the bands server components. */
export function TrackedPseoLink({
  href,
  surface,
  slug,
  label,
  className,
  children,
}: {
  href: string;
  surface: PseoCtaSurface;
  slug: string;
  label?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() => trackPseoCtaClick({ surface, slug, destination: href, label })}
    >
      {children}
    </Link>
  );
}
